import { TEACHERS } from "../const/actionTypes";

import { postAjax, putAjax, deleteAjax } from "../../auth/ApiAuth";
import { getTeacherIds, getTeachersByIds } from "../../api/users";

const RegisterData = {
    username: '',
    password1: '',
    password2: '',
    email: '',
}

export const setTeachers = item => {
    return {
        type: TEACHERS.SET_TEACHERS,
        item
    }
}

export const editTeacher = (editedTeacherData) => ({
    type: TEACHERS.EDIT_TEACHER,
    editedTeacherData
});
export const setEditedTeacher = (editedTeacher) => ({
    type: TEACHERS.SET_EDITED_TEACHER,
    editedTeacher
})
export const resetEditedTeacher = () => ({
    type: TEACHERS.RESET_EDITED_TEACHER
})

const clearTeachers = () => ({
    type: TEACHERS.CLEAR_TEACHERS
});

export const setTeachersLoading = (loading) => ({
    type: TEACHERS.SET_TEACHERS_LOADING,
    loading,
});

export function createTeacher(RegData) {
    RegisterData.username = RegData.get("email").split("@")[0];
    RegisterData.password1 = RegData.get("password");
    RegisterData.password2 = RegData.get("password")
    RegisterData.email = RegData.get("email");
    RegData.delete("password")
    RegData.append("username", RegisterData.username)
    RegData.append("accountType", "teacher")
    if (typeof RegData.get("photoPath") === typeof null) {
        RegData.delete("photoPath")
    }

    return async (dispatch) => {
        async function updateEndUser(results){
            let teacherId = results.user
            let baseurl = `${process.env.REACT_APP_BASE_URL}/api/user/` + teacherId + '/'
            await putAjax(baseurl, RegData, false);
            // Let calling views refresh their own page slice
        }

        let baseurl = `${process.env.REACT_APP_BASE_URL}/rest-auth/registration/`;
        await postAjax(baseurl, RegisterData, updateEndUser);
    }
}

export function deleteTeacher(teacherId) {
    return async (dispatch) => {
        let baseurl = `${process.env.REACT_APP_BASE_URL}/api/user/` + teacherId + '/'
        await deleteAjax(baseurl)
    }
}

export function updateTeacher(RegData, teacherId) {
    if (RegData.get("photoPath") === null) {
        RegData.delete('photoPath');
    }
    return async (dispatch) => {
        let baseurl = `${process.env.REACT_APP_BASE_URL}/api/user/` + teacherId + '/'
        await putAjax(baseurl, RegData, false)
    }

}

export function getAllTeachers({ is_active = true } = {}) {
    return async (dispatch) => {
        dispatch(setTeachersLoading(true));
        dispatch(clearTeachers());
        try {
            const idsResp = await getTeacherIds({ is_active });
            const allIds = idsResp && Array.isArray(idsResp.ids) ? idsResp.ids : [];
            if (allIds.length === 0) {
                dispatch(setTeachers([]));
            } else {
                const resp = await getTeachersByIds(allIds);
                const items = Array.isArray(resp?.results) ? resp.results : (Array.isArray(resp) ? resp : []);
                dispatch(setTeachers(items));
            }
        } catch (err) {
            console.log(err)
        } finally {
            dispatch(setTeachersLoading(false));
        }
    }
}


export default (
    setTeachers,
    editTeacher,
    setEditedTeacher,
    deleteTeacher,
    createTeacher,
    updateTeacher,
    resetEditedTeacher,
    getAllTeachers
)
